
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
const GROUPED = [
    { country: "United States", flag: "https://backendtestinternal.s3.amazonaws.com/flag-US.png", langs: [{ code: "en", native: "English" }] },
    { country: "Australia", flag: "https://backendtestinternal.s3.amazonaws.com/flag-AU.png", langs: [{ code: "en", native: "English" }] },
    { country: "Canada", flag: "https://backendtestinternal.s3.amazonaws.com/flag-CA.png", langs: [{ code: "en", native: "English" }, { code: "fr", native: "Français" }] },
    { country: "Colombia", flag: "https://backendtestinternal.s3.amazonaws.com/flag-CO.png", langs: [{ code: "en", native: "English" }, { code: "es", native: "Español" }] },
    { country: "Germany", flag: "https://backendtestinternal.s3.amazonaws.com/flag-DE.png", langs: [{ code: "en", native: "English" }, { code: "de", native: "Deutsch" }] },
    { country: "Ireland", flag: "https://backendtestinternal.s3.amazonaws.com/flag-IE.png", langs: [{ code: "en", native: "English" }] },
    { country: "Japan", flag: "https://backendtestinternal.s3.amazonaws.com/flag-JP.png", langs: [{ code: "en", native: "English" }, { code: "ja", native: "日本語" }] },
    { country: "Mexico", flag: "https://backendtestinternal.s3.amazonaws.com/flag-MX.png", langs: [{ code: "en", native: "English" }, { code: "es", native: "Español" }] },
    { country: "New Zealand", flag: "https://backendtestinternal.s3.amazonaws.com/flag-NZ.png", langs: [{ code: "en", native: "English" }] },
    { country: "Singapore", flag: "https://backendtestinternal.s3.amazonaws.com/flag-SG.png", langs: [{ code: "en", native: "English" }] },
    { country: "United Kingdom", flag: "https://backendtestinternal.s3.amazonaws.com/flag-GB.png", langs: [{ code: "en", native: "English" }] },
];

function triggerTranslate(lang) {
    const tryChange = setInterval(() => {
        const select = document.querySelector(".goog-te-combo");
        if (select) {
            select.value = lang;
            select.dispatchEvent(new Event("change"));
            clearInterval(tryChange);
        }
    }, 200);
    // 5 sec baad bhi band karo
    setTimeout(() => clearInterval(tryChange), 5000);
}

export default function MobileGoogleTranslate() {
    const [open, setOpen]       = useState(false);
    //  loaded = true by default — Google script ka wait nahi
    const [loaded, setLoaded]   = useState(true);
    const [current, setCurrent] = useState({
        flag: "https://backendtestinternal.s3.amazonaws.com/flag-US.png",
        country: "United States",
        code:  "en,fr,es,de,ja",
        native: "English",
    });
    
const location = useLocation();

const isWhiteBg =
  location.pathname.includes("/customer-stories/") ||
  location.pathname.includes("/services/");

    const dropRef = useRef(null);

    useEffect(() => {
        //  Script load karo background mein — UI block nahi hogi
        window.googleTranslateElementInit = () => {
            try {
                if (!document.querySelector(".goog-te-combo")) {
                    new window.google.translate.TranslateElement(
                        { pageLanguage: "en", includedLanguages: "en,fr,es,de,ja", autoDisplay: false },
                        "mobile_translate_container"
                    );
                }
            } catch (e) {}
        };

        if (window.google?.translate?.TranslateElement) {
            window.googleTranslateElementInit();
            return;
        }

        if (!document.getElementById("google-translate-script")) {
            const script    = document.createElement("script");
            script.id       = "google-translate-script";
            script.src      = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async    = true;
            document.body.appendChild(script);
        }
    }, []);

    // Outside click close
    useEffect(() => {
        const close = (e) => {
            if (dropRef.current && !dropRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    const selectLang = (flag, country, code, native) => {
        setCurrent({ flag, country, code, native });
        setOpen(false);
        triggerTranslate(code);
    };

    return (
        <>
            <div id="mobile_translate_container" style={{ position: "absolute", left: "-9999px", visibility: "hidden" }} />

            <div className="gt-root" ref={dropRef}>

                <button className="gt-btn" onClick={() => setOpen(v => !v)} aria-label="Select language">
                    <svg width="1.5rem" height="1.5rem" viewBox="0 0 24 24"
                        fill="none" stroke={`${isWhiteBg ? "#3043ba" : "#fff"}`} strokeWidth="1.8">
                        <circle cx="12" cy="12" r="9" />
                        <path d="M12 3a15.3 15.3 0 0 1 4 9 15.3 15.3 0 0 1-4 9 15.3 15.3 0 0 1-4-9 15.3 15.3 0 0 1 4-9z" />
                        <path d="M3 12h18" />
                    </svg>
                </button>

                {open && (
                    <div className="gt-dropdown">
                        <div className="gt-panel-title">Select Region</div>

                        {/*  loaded always true — seedha list dikhao */}
                        {GROUPED.map((group, gi) => (
                            <div key={group.country} className="gt-group">
                                {gi > 0 && <div className="gt-divider" />}

                                <div className="gt-country-row">
                                    <img src={group.flag} alt={group.country} className="gt-country-flag" />
                                    <span className="gt-country-name">{group.country}</span>
                                </div>
 <div className="" style={{display:'flex',flexWrap:'wrap', paddingLeft:'1.3rem'}}>

                                {group.langs.map(l => {
                                    const isActive = current.country === group.country && current.code === l.code;
                                    return (
                                        <button 
                                        style={{width:'50%'}}
                                            key={l.code}
                                            className={`gt-lang ${isActive ? "active" : ""}`}
                                            onClick={() => selectLang(group.flag, group.country, l.code, l.native)}
                                        >
                                            <span>{l.native}</span>
                                            {isActive && (
                                                <svg width="13" height="13" viewBox="0 0 24 24"
                                                    fill="none" stroke="currentColor" strokeWidth="2.8">
                                                    <polyline points="20 6 9 17 4 12" />
                                                </svg>
                                            )}
                                        </button>
                                    );
                                })}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <style>{`
        .skiptranslate,
        .goog-te-banner-frame,
        .goog-te-balloon-frame,
        #goog-gt-tt,
        .goog-tooltip,
        .VIpgJd-ZVi9od-ORHb           { display: none !important; }
        .goog-text-highlight           { background: none !important; box-shadow: none !important; }
        body                           { top: 0 !important; position: static !important; }
        html body                      { margin-top: 0 !important; }

        .gt-root { position: relative; font-family: 'DM Sans', sans-serif; }

        .gt-btn {
          display: flex; align-items: center; gap: 8px;
          background: transparent;
        //   border: 1px solid rgba(255,255,255,0.22);
          color: #fff;
        //   border-radius: 10px;
          padding: 7px 12px;
          cursor: pointer;
          font-size: 13px; font-weight: 500;
          transition: border-color 0.2s, background 0.2s;
          white-space: nowrap;
          outline: none !important;
          box-shadow: none !important;
          -webkit-tap-highlight-color: transparent;
        }
        // .gt-btn:hover { border-color: rgba(255,255,255,0.45); background: rgba(255,255,255,0.07); }
        .gt-btn:focus, .gt-btn:focus-visible { outline: none !important; box-shadow: none !important; }

        .gt-flag-img { width: 22px; height: 15px; object-fit: cover; border-radius: 3px; box-shadow: 0 1px 3px rgba(0,0,0,0.4); flex-shrink: 0; }
        .gt-btn-label { color: #e2e8f0; font-size: 13px; }
        .gt-caret { opacity: 0.5; transition: transform 0.2s; flex-shrink: 0; }
        .gt-caret.open { transform: rotate(180deg); }

        .gt-dropdown {
          position: absolute;
          right: 0; top: calc(100% + 10px);
          background: #fff;
          border: 1px solid rgba(99,179,237,0.18);
          border-radius: 14px;
          padding: 8px;
          width: 230px;
        //   max-height: 400px;
          overflow-y: auto;
          z-index: 9999;
          animation: gtIn 0.18s cubic-bezier(0.16,1,0.3,1);
          scrollbar-width: thin;
          scrollbar-color: rgba(0,0,0,0.08) transparent;
        }
        .gt-dropdown::-webkit-scrollbar       { width: 4px; }
        .gt-dropdown::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.1); border-radius: 4px; }

        @keyframes gtIn {
          from { opacity:0; transform: translateY(-8px) scale(0.97); }
          to   { opacity:1; transform: translateY(0) scale(1); }
        }

        .gt-panel-title { font-size: 10px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #475569; padding: 4px 8px 8px; }

        .gt-group   { margin-bottom: 2px; border-top: 1px solid #d6d6d6;}
        .gt-divider { height: 1px; background: rgba(0,0,0,0.07); margin: 4px 0; }

        .gt-country-row { display: flex; align-items: center; gap: 9px; padding: 6px 8px 3px; }
        .gt-country-flag { width: 24px; height: 16px; object-fit: cover; border-radius: 3px; flex-shrink: 0; }
        .gt-country-name { font-size: 0.9rem; font-weight: 600; color: #000;}

        .gt-lang {
        display: flex; align-items: center; justify-content: center;
          width: 100%; text-align: left;
          padding: 6px 10px 6px 10px;
          border: none; background: none;
          color: #1012a2; font-size: 0.9rem;
     
          cursor: pointer; border-radius: 8px;
          transition: background 0.15s, color 0.15s;
              font-weight: 700;
    line-height: 1.5rem;
        }
        .gt-lang:hover  { background: rgba(59,130,246,0.07); color: #1e293b; }
        .gt-lang.active { background: rgba(59,130,246,0.15); color: #60a5fa; font-weight: 600; }

        .gt-loading { color: #475569; padding: 12px 10px; font-size: 13px; }
         @media (max-width: 1000px) {
          .gt-root{
          
          margin-top:0.75rem;}
        }        
        @media (max-width: 600px) {
          .gt-btn-label { display: none; }
          .gt-dropdown  { right: -10px; width: 210px; }
        }
      `}</style>
        </>
    );
}